module.exports = __webpack_public_path__ + "img/second-image-msg.27fc0f15.png";